import { dashboardProviderId, microsoftTelemetryGroupId, dashboard } from "../../telemetry/TraceLogging";
import { tryGetHostApi } from "./externalApi";
export async function initializeTelemetryProviders() {
    const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
    if (telemetryApi) {
        await telemetryApi.createTraceLoggingProvider(dashboardProviderId, microsoftTelemetryGroupId, dashboard);
    }
}
